module.exports = __webpack_public_path__ + "img/choose-up-Up Cultura.a0395be4.png";